import { fromJS } from 'immutable';
import { Logger } from 'logger';
import { handleActions } from 'redux-actions';
import { ADD_ITEM, DELETE_ITEM, LOAD_LAYOUT, UPDATE_ITEM, UPDATE_LAYOUT } from './constants';

let maxZIndex = 0;

export function getNextMaxZIndex() {
  return maxZIndex++;
}

const CURRENT_LOCAL_STORAGE_VERSION = 2

const debugLog = Logger.create('redux/layout/reducer.ts')

const initialState = fromJS({
  currentTab: 'Dashboard',
  initialized: false,
  table: {
    Analysis: {
      grid: [
        {
          h: 42,
          key: Math.floor(Math.random() * 10 ** 18),
          type: 'instruments',
          width: 30,
          x: 0,
          y: 6,
          z: 0
        }
      ],
      tabName: 'Analysis',
    },
    Dashboard: {
      grid: [
        {
          h: 160,
          key: Math.floor(Math.random() * 10 ** 18),
          type: 'quotes',
          width: 1550,
          x: 5,
          y: 5,
          z: 1
        },
        {
          h: 160,
          key: Math.floor(Math.random() * 10 ** 18),
          type: 'advancer-decliner',
          width: 550,
          x: 1560,
          y: 5,
          z: 2
        },
        {
          h: 675,
          key: Math.floor(Math.random() * 10 ** 18),
          secondSym: [],
          symbol: 'VPMES1',
          type: 'chart',
          width: 1550,
          x: 5,
          y: 175,
          z: 3
        },
        {
          h: 675,
          key: Math.floor(Math.random() * 10 ** 18),
          secondSym: [],
          symbol: 'ES',
          type: 'watchboxItem',
          width: 350,
          x: 1560,
          y: 175,
          z: 4
        },
        {
          h: 675,
          key: Math.floor(Math.random() * 10 ** 18),
          secondSym: [],
          symbol: 'ES',
          type: 'watchboxItem',
          width: 350,
          x: 1750,
          y: 215,
          z: 5
        },
        {
          h: 500,
          key: Math.floor(Math.random() * 10 ** 18),
          secondSym: [],
          type: 'esastamomo',
          width: 2100,
          x: 5,
          y: 900,
          z: 9
        },
        {
          h: 280,
          key: Math.floor(Math.random() * 10 ** 18),
          secondSym: [],
          type: 'modelOutput',
          width: 1045,
          x: 5,
          y: 1410,
          z: 7
        },
        {
          h: 280,
          key: Math.floor(Math.random() * 10 ** 18),
          secondSym: [],
          type: 'trendModel',
          width: 1045,
          x: 1060,
          y: 1410,
          z: 8
        },
        {
          h: 300,
          key: Math.floor(Math.random() * 10 ** 18),
          secondSym: [],
          type: 'activeRotations',
          width: 2100,
          x: 5,
          y: 1710,
          z: 6
        },
        {
          h: 350,
          key: Math.floor(Math.random() * 10 ** 18),
          secondSym: [],
          type: 'completedRotations',
          width: 2100,
          x: 5,
          y: 2020,
          z: 7
        }
      ],
      tabName: 'Dashboard',
    },
    Settings: {
      grid: [
      {
      h: 42,
      key: 946825416724789100,
      symbol: 'VPMES1',
      type: 'chart',
      width: 40,
      x: 0,
      y: 0,
      z: 0
      }
      ],
      tabName: 'Settings',
    }
  },
  timestamp: '2017-12-01T05:49:45.625Z',
  version: CURRENT_LOCAL_STORAGE_VERSION
});

type WidgetTypes = 'quotes' | 'advancer-decliner' | 'tables' | 'watchbox' | 'chart' | 'news' | 'alerts' | 'watchboxItem'

interface ILocalStorage {
  currentTab: 'Dashboard',
  initialized: boolean,
  table: {
    [key: string]: {
      grid: Array<{
          h: number,
          key: number,
          type: WidgetTypes,
          width: number,
          x: number,
          y: number,
          z: number
        }>,
      tabName: 'Analysis' | 'Dashboard' | 'Settings',
    },
  },
  timestamp: string, // ISO date string
  version: number
}

function upgradeLocalStorage(currentStorage: ILocalStorage): ILocalStorage {
  switch (currentStorage.version) {
    case 1: {
      let zIndex = 1;
      currentStorage.version++
      try {
        // v1 -> v2 is a dashboard change
        if (currentStorage.table.Dashboard) {
          currentStorage.table.Dashboard.grid = currentStorage.table.Dashboard.grid.map(item => ({
            ...item,
            h: item.h * 15,
            width: Math.floor(item.width * (window.innerWidth / 100)),
            x: Math.floor(item.x * (window.innerWidth / 100)),
            y: item.y * 15,
            z: zIndex++
          }))
        }
      } catch (e) {
        debugLog(`failed to upgrade local storage from v1 to v2: ${e.message}`)
      }
    }
    break;
    default:
      debugLog(`Something went terribly wrong, ended up in default switch case on upgrade. current version: ${currentStorage.version}`)
      currentStorage.version = CURRENT_LOCAL_STORAGE_VERSION
      break;
  }
  if (currentStorage.version === CURRENT_LOCAL_STORAGE_VERSION) {
    return currentStorage;
  }
  return upgradeLocalStorage(currentStorage)
}

function saveLayout(state: any) {
  state.timestamp = new Date().toISOString();
  localStorage.setItem('current_grid', JSON.stringify(state));
}

const GRID_SIZE = 100;
const WIDGET_WIDTH = 70;

export default handleActions(
  {
    [LOAD_LAYOUT]: (state: any) => {
      const loadedGrid = localStorage.getItem('current_grid')
      if (loadedGrid) {
        const localGrid = JSON.parse(loadedGrid);
        const upgradedLocalGrid = upgradeLocalStorage(localGrid)
        maxZIndex = upgradedLocalGrid.table.Dashboard.grid.reduce((acc, item) => acc < item.z ? item.z : acc, 0)
        return fromJS(upgradedLocalGrid)
        // if (localGrid && Date.parse(localGrid.timestamp) > 1516589595947) {
        //   localGrid.initialized = true;
        //   return fromJS(localGrid);
        // }
      }
      return state.set('initialized', true);
    },
    [UPDATE_LAYOUT]: (state: any, { payload }: any) => {
      const mutable = state.toJS();
      const grid = mutable.table[mutable.currentTab].grid;
      // payload array of grid items. w, x, y, h, and i (string key)
      payload.forEach((layout: any) => {
        const currentGrid = grid.find((gridElement: any) => gridElement.key === Number(layout.i));
        if (currentGrid) {
          currentGrid.width = layout.w !== undefined ? layout.w : currentGrid.width;
          currentGrid.x = layout.x !== undefined ? layout.x : currentGrid.x;
          currentGrid.y = layout.y !== undefined ? layout.y : currentGrid.y;
          currentGrid.h = layout.h !== undefined ? layout.h : currentGrid.h;
          currentGrid.z = layout.z !== undefined ? layout.z : currentGrid.z;
        }
      });
      saveLayout(mutable);
      return fromJS(mutable);
    },
    [ADD_ITEM]: (state: any, { payload }: any) => {
      const mutable = state.toJS();
      const { options } = payload;
      const widget = {
        h: options.h,
        isActive: false,
        key: Math.random() * 10 ** 18,
        secondSym: '',
        symbol: options.symbol,
        type: options.type,
        width: options.width,
        x: mutable.table[mutable.currentTab].grid.length * WIDGET_WIDTH % GRID_SIZE,
        y: 0,
        z: getNextMaxZIndex()
      };

      mutable.table[mutable.currentTab].grid = mutable.table[mutable.currentTab].grid.concat(widget);
      saveLayout(mutable);
      return fromJS(mutable);
    },
    [UPDATE_ITEM]: (state: any, { payload }: any) => {
      const { key } = payload;
      const mutable = state.toJS();
      const index = mutable.table[mutable.currentTab].grid.findIndex((element: any) => element.key === key);
      mutable.table[mutable.currentTab].grid[index] = payload;
      saveLayout(mutable);
      return fromJS(mutable);
    },
    [DELETE_ITEM]: (state: any, { payload }: any) => {
      const { id } = payload;
      const mutable = state.toJS();
      const newTable = mutable.table[mutable.currentTab].grid.filter((element: any) => element.key !== id);
      mutable.table[mutable.currentTab].grid = newTable;
      saveLayout(mutable);
      return fromJS(mutable);
    }
  },
  initialState
);
